// extracted by mini-css-extract-plugin
export var image = "NativeHeroImage-module--image--a02c9";